import React, { useEffect } from "react";
import { PAYMENT_TENDER_TYPES } from 'common/constants/SharedConstants';
import { getPaymentOptionsTemplate } from './templates/PaymentViewTemplates';
import {dispatchPaymentRequest} from '../utils/JapanPaymentUtils';
import {useSelector } from 'react-redux';
import CanalPaymentHiddenForm from '../hiddenForms/CanalPaymentHiddenForm';
import { redirectToOrderProcessingPage } from 'common/utilities/utils';


const JapanPaymentView = props => {
  const { checkoutDetails, updateCheckoutDetails } = props;

  const {paymentsReducer} = useSelector(data => data);

  useEffect(() => {
    checkoutDetails?.isUpdatedOrderActionRequest && updateCheckoutDetails({ dispatchOrderAction: true });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [checkoutDetails?.isUpdatedOrderActionRequest]);


   useEffect(() => {
     if (checkoutDetails?.tender?.name === PAYMENT_TENDER_TYPES?.PAY_BY_CASH) {
       checkoutDetails?.orderId &&
         checkoutDetails?.isCreateOrderValidateCompleted &&
         redirectToOrderProcessingPage(props)
     }
     else {
       (checkoutDetails?.isCreateOrderValidateCompleted && checkoutDetails?.orderId && checkoutDetails?.isClickPlaceOrder &&
         checkoutDetails?.tender?.name === PAYMENT_TENDER_TYPES?.CANAL) &&
         dispatchPaymentRequest(props);
     }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [checkoutDetails?.isCreateOrderValidateCompleted]);
  

  return <>
  {getPaymentOptionsTemplate(checkoutDetails, updateCheckoutDetails)}
  <div className='hidden'>
          {checkoutDetails?.tender?.name === PAYMENT_TENDER_TYPES?.CANAL && (
            <CanalPaymentHiddenForm checkoutDetails={checkoutDetails} data={paymentsReducer} />
          )}
         
        </div>
  </>
}

export default JapanPaymentView;